module.exports = __webpack_public_path__ + "img/SuccessIcon.b47e1a5d.svg";